import permissions from "app/permissions";
import React, { useCallback, useEffect, useState } from "react";
import { Datagrid, FunctionField, TextField, useRecordContext } from "react-admin";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import WorkedOutDialog from "./WorkedOutDialog";
import { studentRequests } from "api/studentApi";

const ClassesForMakeUpExpanded = () => {
  const record = useRecordContext();
  const [classData, setClassData] = useState([]);

  const loadExpanded = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getMakeUpClassesForStudent(record?.studentEducationId, record.disciplineId),
        null,
        "GET",
      );
      setClassData(data || []);
    } catch (err) {
      console.error(err);
    }
  }, [record?.studentEducationId, record?.disciplineId]);

  useEffect(() => {
    loadExpanded();
  }, [loadExpanded]);

  return (
    <Datagrid
      data={classData.classes}
      rowClick={false}
      bulkActionButtons={false}
    >
      <TextField
        label="Дата"
        source="classDate"
      />
      <TextField
        label="Тема"
        source="topicName"
      />
      <FunctionField
        render={rec => (
          <SecuredComponent permission={permissions.canManageMakeUps}>
            <WorkedOutDialog
              studentEducationId={record?.studentEducationId}
              classId={rec.classId}
              onSuccess={loadExpanded}
            />
          </SecuredComponent>
        )}
      />
    </Datagrid>
  );
};

export default ClassesForMakeUpExpanded;
